import { render, staticRenderFns } from "./selectOrderPage.vue?vue&type=template&id=0dc44f7c&scoped=true"
import script from "./selectOrderPage.vue?vue&type=script&lang=js"
export * from "./selectOrderPage.vue?vue&type=script&lang=js"
import style0 from "./selectOrderPage.vue?vue&type=style&index=0&id=0dc44f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc44f7c",
  null
  
)

export default component.exports